import * as React from "react";
import ReactModal from "react-modal";
import cx from "classnames";
import styles from "./styles.scss";
import useRouter from "use-react-router";
import { getUrlQueries } from "utilities/routes";
import { isStandaloneGigMode } from "utilities/embed";

interface Props {
  children: React.ReactNode;
  className?: string;
  noPadding?: boolean;
  onRequestClose?: () => void;
  isOpen?: boolean;
}

export default function LegacyModal({ children, className, isOpen = true, onRequestClose, noPadding }: Props) {
  const { location } = useRouter();
  const { fullScreen } = getUrlQueries(location.search);
  const standaloneGig = isStandaloneGigMode();
  return (
    <ReactModal
      isOpen={isOpen}
      className={cx(styles.content, noPadding && styles.noPadding, standaloneGig && styles.standaloneGigContent, className)}
      overlayClassName={cx(styles.overlay, fullScreen && styles.transparent, standaloneGig && styles.standaloneGigOverlay)}
      onRequestClose={onRequestClose}
      appElement={getRoot()}
    >
      {children}
    </ReactModal>
  );
}

let root: HTMLElement | undefined;

function getRoot() {
  if (!root) root = document.getElementById("root") || undefined;

  return root;
}
